import { useQuery } from '@tanstack/react-query';
import getPublicText from 'queries/texts/get-public-text';
import { PublicProjectTexts } from 'types/types';
import useProjectId from './useProjectId';

interface ExportProps {
  texts: PublicProjectTexts;
  isLoading: boolean;
}

const useFetchTexts = (): ExportProps => {
  const projectId = useProjectId();
  const { data, isLoading } = useQuery(getPublicText(projectId));

  const defaults: PublicProjectTexts = {
    PROJECT_RULES: '',
    PROJECT_NAME: '',
    FRONTPAGE_MAIN: '',
    LOGIN_BANNER: '',
  };

  if (isLoading || !data) {
    return { texts: defaults, isLoading: true };
  }

  return { texts: { ...defaults, ...data }, isLoading };
};

export default useFetchTexts;
